module.exports = __webpack_public_path__ + "static/Hero-Banner-Retail-rapidfresh-0a80a1cb68daf02f890c81626ba409f8.png";